import React, { useEffect, useRef, useState } from 'react';

function PlanetEmbed({
    accessToken,
    formGuid,
    fiscalNumber,
    isSandbox,
    environment,
    onSuccess = () => {},
    onError = () => {},
    onClose = () => {},
}) {
    const [planet, setPlanet] = useState(null);

    const $plugin = useRef(null);

    function initialize() {
        if (!planet) {
            setPlanet(
                new planetPOSPlugin($plugin.current, {
                    useSandbox: isSandbox,
                    auth: {
                        token: accessToken,
                        preIssuedFormId: formGuid,
                    },
                    invoiceFiscalNumber: fiscalNumber,
                    onSuccess: onSuccess,
                    onError: onError,
                    onClose: onClose,
                }),
            );
        }
    }

    const startScript = () => {
        const script = document.createElement('script');
        script.src = !isSandbox
            ? 'https://europe-taxfree.planetpayment.com/POSPlugin/scripts/POSPlugin.posPlugin.js'
            : 'https://europeuat-taxfree.planetpayment.com/POSPlugin/scripts/POSPlugin.posPlugin.js';

        script.onload = () => {
            initialize();
        };
        script.onerror = () => {
            console.error('Failed to load Planet plugin script');
        };

        document.head.appendChild(script);
    };

    useEffect(() => {
        startScript();
    }, []);

    return <div ref={$plugin}></div>;
}

export default PlanetEmbed;
